import React from "react";
import { useEffect, useState, useRef } from "react";
import "./style.css";
import { BouncingLoader } from "../../pure-components/Loader";
import API from "../../services/api";
import { Link } from "react-router-dom";
import defaultImage from "../../assets/default_music.png";
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import CatalogAlbum from "./catalog-album";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Catalog = (props) => {
  
  const ref = useRef(null);
  const history=useHistory()
  const [searchText,setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [catalogList, setCatalogList] = useState([]);
  const [catalogs, setCatalogs] = useState([]);
  
  
  useEffect(() => {
      (async() => {
        if(!window.location.pathname.includes("album"))
          await loadCatalogList()
      })()
    
  }, [])

  const loadCatalogList = async() => {
    setLoading(true);
    await API.loadCatalogs().then((resp) => {
      // console.log("Catalogs : ", resp);
      setCatalogList(resp.data.Libraries);
      setCatalogs(resp.data.Libraries);
    }).catch((err) => {
      console.log("Catalogs Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"Catalog list loading Error."} />);
    }).finally(() => {
      setLoading(false);
    })
  }
  const handleSearch = async(e) => {
    
    if(e.key === 'Enter' && !loading){
      if(searchText?.length > 0){
        const filteredList = catalogList?.filter((elem) => elem.Name?.toLowerCase().includes(searchText.toLowerCase()) || elem.Detail?.toLowerCase().includes(searchText.toLowerCase()))
        setCatalogs(filteredList)
      }else{
        setCatalogs(catalogList);
      }
    }
  };

  const loadCatalogAlbums = (catalogData) => {
    history.push(`catalog/albums/${catalogData.ID}`, {catalogData : catalogData})
  }
  return (
    <>
    {!window.location.pathname.includes("/album") ? 
    <div className="lg:px-8 items-center flex-1 pt-20 lg:pt-3 sm:mx-8 mx-4 lg:mx-20 playlist">
      <div className="w-full rounded-full aisearch border-pink flex">
        <input
          onChange={event => { setSearchText(event.target.value) }}
          onKeyDown={handleSearch}
          className="self-center w-full md:truncate bg-white outline-none cursor-pointer placeholder-textGray-600 rounded-full pl-2 py-1"
          placeholder="Search Catalog"
          disabled={loading}
          value={searchText}
        />
      </div>
      
      <div className="border-t my-2"></div>
      
      <div className="w-full">
        {loading && (
          <div className="w-full">
            <BouncingLoader />
          </div>
        )}
        
        {!loading && !(catalogs?.length > 0) ? (
          <div className="text-xl text-center text-red-500 my-5">
            No Catalog Found
          </div>
        ) : (
          <div className="bg-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-8 mt-10">
            {catalogs?.map((elem) => (
              <div onClick={() => loadCatalogAlbums(elem)} key={elem?.ID}>
                <div className="music-tile" key={elem?.ID}>
                  <div className="image-container">
                    {elem != null && elem?.LibraryLogoUrl != null ? (
                      <img
                        src={elem?.LibraryLogoUrl || defaultImage}
                        alt=""
                        onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                        className="sm:flex border sm:cursor-pointer rounded-2xl w-full h-auto object-cover"
                        loading="lazy"
                      />
                    ) : (
                      <img
                        src={defaultImage}
                        alt=""
                        className="sm:flex border-b sm:cursor-pointer music-image justify-center align-middle w-full h-auto"
                        loading="lazy"
                      />
                    )}
                    <span className="play_icon" title="Play"></span>
                  </div>
                  <div className="p-2">
                    <p className="text-sm"><b>{elem?.Name}</b></p>
                    {elem.Detail?.length > 0 &&
                      <p className="text-sm font-light text-left description line-clamp-2"
                        title={elem.Detail}
                      >
                        {elem.Detail || elem?.Name}
                      </p>
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     : <div>
        <CatalogAlbum />
      </div>
    }
    </>
  );
};

export default Catalog;